import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import type { CartCalculationOrderResponse } from '~/api/Catalog';
import { ETADeliveryMethodType } from '~/api/ETADeliveryMethodType';
import { company } from '~/company/Company';
import Panel from '~/components/Panel/Panel';
import Promocode2 from '~/components/Promocode2/Promocode2';
import MobileHeaderLayout from '~/pages/Main/MobileHeader/MobileHeaderLayout';
import MobileHeaderTitle from '~/pages/Main/MobileHeader/MobileHeaderTitle';

import { checkoutStore, userStore } from '~/stores';

import styles from './CheckoutContent.module.scss';
import stylesCd from './CheckoutContentCd.module.scss';
import DeliveryAddressRestriction from './components/DeliveryAddressRestriction';
import DeliveryTime from './components/DeliveryTime';
import MapStatic from './components/MapStatic/MapStatic';
import PaymentPanel from './components/PaymentPanel/PaymentPanel';
import Total from './components/Total/Total';

export interface CheckoutContentMobileProps {
  handleSelectDateModal: (
    index: number,
    order: CartCalculationOrderResponse,
  ) => void;
  hasExpressDelivery: boolean | undefined;
  totalDeliveryFee: number;
  isRestrictedPayment: boolean;
  isDeliveryMethodSelectionAvailable: boolean;
  isPromoLoading: boolean;
  openDeliveryModal: () => void;
  promocodeUse: boolean | null;
}

const CheckoutContentMobileCD: FC<CheckoutContentMobileProps> = ({
  handleSelectDateModal,
}) => {
  const { t } = useTranslation();

  const loyaltyPointsWorkWithPromocode =
    userStore.loyaltyPointsStore.workWithPromocode;
  const loyaltyPointsUse = userStore.loyaltyPointsStore.useLoyaltyPoints;

  const isPickUpOrder =
    checkoutStore.deliveryMethod === ETADeliveryMethodType.ClickAndCollect;

  return (
    <>
      <MobileHeaderLayout
        content={
          <MobileHeaderTitle
            text={t('checkout')}
            isVisibleBackButton={!company.newDesignSystemEnabled}
          />
        }
      />
      <div
        className={classes([
          'checkout phone',
          styles.checkoutMobileContainer,
          isPickUpOrder && styles.mobilePickUpCheckout,
        ])}
      >
        <MapStatic />
        <div className={styles.checkoutMobileInner}>
          {company.showCheckoutAddressRestrictionBanner && (
            <DeliveryAddressRestriction />
          )}
          <DeliveryTime handleSelectDateModal={handleSelectDateModal} />
          <PaymentPanel />
          <Panel
            classNames={stylesCd.promocodePanel}
            icon="promocode"
            iconSize={24}
            iconClassName={stylesCd.promocodePanelIconContainer}
          >
            <Promocode2
              disabled={!loyaltyPointsWorkWithPromocode && loyaltyPointsUse}
            />
          </Panel>
          <Total />
        </div>
      </div>
    </>
  );
};

export default observer(CheckoutContentMobileCD);
